import { Suspense } from 'react';
import { useLocation } from 'react-router';
import AliciaChatbotModule from '../../features/AliciaChatbotModule/AliciaChatbotModule';
import AliciaChatbotSkeleton from '../../features/AliciaChatbotModule/AliciaChatbotSkeleton';
import { isChatbotForbiddenRoute, isChatbotHiddenOnPage } from '../../core/constants/chatbotRoutes';
import { useIsDesktop } from '../../core/hooks/useMediaQuery';
import { useAuth } from '../../core/contexts/AuthContext';
import { useApp } from '../../core/contexts/AppContext';

const ChatbotWrapper = () => {
  const { isFullyAuthenticated } = useAuth();
  const { isNotificationDrawerOpen, isModuleDrawerOpen } = useApp();
  const location = useLocation();
  const isDesktop = useIsDesktop();

  if (!isFullyAuthenticated) return null;

  const isForbiddenRoute = isChatbotForbiddenRoute(location.pathname);
  const isChatbotHidden = isDesktop
    ? isChatbotHiddenOnPage(location.pathname) || isNotificationDrawerOpen || isModuleDrawerOpen
    : false;

  return (
    <Suspense fallback={!isForbiddenRoute && !isChatbotHidden ? <AliciaChatbotSkeleton /> : null}>
      <AliciaChatbotModule destroy={isForbiddenRoute} hide={isChatbotHidden} />
    </Suspense>
  );
};

export default ChatbotWrapper;
